import React, { FunctionComponent } from 'react';
import cx from 'ui/helper/prefixed-class-names';
import Translate from 'ui/atoms/translate';
import { UserDataSet } from 'ui/types/user-data-set';
import CardItem from 'src/ui/atoms/card-item';

export interface IssuerInformationProps {
  userDataSet: UserDataSet;
}

const IssuerInformation: FunctionComponent<IssuerInformationProps> = (props) => {
  const { userDataSet } = props;

  return (
    <div className={cx('user-information')}>
      {Object.entries(userDataSet.fields).map((value: any, key: number) => (
        <CardItem
          title={<Translate name={`dashboardIssuerIssuerDetails.${userDataSet.key}.${value[0]}`} />}
          content={value[1]}
          key={key}
        />
      ))}
    </div>
  );
};

export default IssuerInformation;
